import api from "../ApiConfig";
import { API_URL, Apis } from "../../config";
import { NotificationManager } from "react-notifications";
import unauthService from "../unauth";

const SubmitArticle = async (data) => {
  try {
    const result = await api.post(Apis.GetAllArticlePath, data, {
      // withCredentials: true,
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (result.status === 401) {
      unauthService();
    }
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    NotificationManager.success(result.data.message, "Success");
    return result.data;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const UploadPaymentProof = async (data, id) => {
  try {
    const result = await api.post(
      `${Apis.GetAllArticlePath}/upload-payment-proof?id=${id}`,
      data,
      {
        // withCredentials: true,
        headers: {
          // 'Content-Type': 'multipart/form-data'
          "Content-Type": "application/json",
        },
      }
    );
    let response = JSON.parse(result.data);
    console.log("response-40", response.data);

    let parsedData = JSON.parse(response.body);

    if (result.status === 401) {
      unauthService();
    }

    if (!parsedData.success) {
      NotificationManager.error(parsedData.message);
      return null;
    }

    return parsedData;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const UpdateArticleStatus = async (id, data) => {
  try {
    const result = await api.put(
      `${Apis.GetAllArticlePath}/updatePaymentStatus/${id}`,
      data,
      {
        // withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (result.status === 401) {
      unauthService();
    }
    if (result.data.error) {
      NotificationManager.error(result.data.error);
      return null;
    }
    NotificationManager.success(result.data.message, "Success");
    return result;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const UpdateArticle = async (data, id) => {
  try {
    const result = await api.put(`${Apis.GetAllArticlePath}?id=${id}`, data, {
      // withCredentials: true,
      headers: { "Content-Type": "application/json" },
    });
    let response = JSON.parse(result.data);
    let parsedData = JSON.parse(response.body);

    if (response.statusCode === 401) {
      unauthService();
    }

    if (!parsedData.success) {
      NotificationManager.error(parsedData.message);
      return null;
    }
    NotificationManager.success("Payment Form updated successfully", "Success");
    return result;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const getArticleByUserId = async (filterVal) => {
  try {
    const response = await api.get(
      `${Apis.GetAllArticlePath}/filter/?id=${filterVal.id}&searchText=${filterVal.searchText}&pageNumber=${filterVal.pageNumber}&pageSize=${filterVal.pageSize}&status=${filterVal.status}&PublicationId=${filterVal.PublicationId}&manualJournalId=${filterVal.manualJournalId}`,
      {
        // withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    let parsedData = JSON.parse(response.data);
    let result = JSON.parse(parsedData.body);
    console.log("useridresult", result);

    // if (result.data.error) {
    //     NotificationManager.error(result.data.error);
    //     return null;
    // }
    return result.additionalData;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error.status);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const getArticleByJournal = async (filterVal) => {
  console.log("---------------------------------------");
  console.log("filterVal", filterVal);
  try {
    const response = await api.get(
      `${Apis.GetAllArticlePath}/journal/?userId=${filterVal.id}&searchText=${filterVal.searchText}&pageNumber=${filterVal.pageNumber}&pageSize=${filterVal.pageSize}&status=${filterVal.status}&PublicationId=${filterVal.PublicationId}&month=${filterVal.month}`,
      {
        // withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    let parsedData = JSON.parse(response.data);
    let result = JSON.parse(parsedData.body);
    console.log("resultjournal", result);

    if (parsedData.statusCode === 401) {
      unauthService();
    }
    if (!result.success) {
      NotificationManager.error(result.data.error);
      return null;
    }

    return result.additionalData;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    // NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const DeleteArticle = async (id) => {
  try {
    const result = await api.delete(`${Apis.GetAllArticlePath}?id=${id}`, {
      // withCredentials: true,
      // headers: { 'Content-Type': 'multipart/form-data' }
    });
    let response = JSON.parse(result.data);
    console.log("result--", result);
    console.log("response--", response);
    if (response.statusCode === 401) {
      unauthService();
    }

    // if (!parsedData.success) {
    //     NotificationManager.error(parsedData.message);
    //     return null;
    // }
    NotificationManager.success("Article Deleted successfully", "Success");
    return result;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};
const getFilePreSIgnedUrl = async (data) => {
  try {
    const response = await api.get(`${Apis.GetFileViewPath}?key=${data.key}`, {
      // withCredentials: true,
      headers: { "Content-Type": "multipart/form-data" },
    });
    let parsedData = JSON.parse(response.data);

    let result = JSON.parse(parsedData.preSignedURL.body);

    return result.additionalData;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in getUserLogin:", error);
    NotificationManager.error("An error occurred while logging in.");
    return null;
  }
};

const updatePaymentDetails = async (articleId, data) => {
  try {
    const result = await api.post(
      `${Apis.GetAllArticlePath}/updatePaymentDetails?id=${articleId}`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    let response = JSON.parse(result.data);
    let parsedData = JSON.parse(response.body);

    if (response.statusCode === 401) {
      unauthService();
    }

    if (!parsedData.success) {
      NotificationManager.error(parsedData.message);
      return null;
    }
    NotificationManager.success(
      "Payment details updated successfully",
      "Success"
    );
    return parsedData;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in updatePaymentDetails:", error);
    NotificationManager.error(
      "An error occurred while updating payment details."
    );
    return null;
  }
};

const addDiscountToArticle = async (data) => {
  try {
    const result = await api.post(
      `${API_URL}/articles/addDiscountToArticle`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    let response = JSON.parse(result.data);
    let parsedData = JSON.parse(response.body);

    if (response.statusCode === 401) {
      unauthService();
    }

    if (!parsedData.success) {
      NotificationManager.error(parsedData.message);
      return null;
    }
    NotificationManager.success("Discount added successfully", "Success");
    return parsedData;
  } catch (error) {
    if (error.status === 401) {
      unauthService();
    }
    console.error("Error in addDiscountToArticle:", error);
    NotificationManager.error("An error occurred while adding discount.");
    return null;
  }
};

export default {
  SubmitArticle,
  getArticleByUserId,
  UploadPaymentProof,
  UpdateArticle,
  getArticleByJournal,
  UpdateArticleStatus,
  getFilePreSIgnedUrl,
  DeleteArticle,
  updatePaymentDetails,
  addDiscountToArticle,
};
